import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { addParcelStatus } from '../../../redux/parcels/slice.parcels'
import { showProblem, showDashedResponseText } from '../showResponseText'

// The registry shows this for a parcel that is `created` or `pickup-created`.
export default function Booking({ parcel, onChanged }) {
  const { t } = useTranslation('parcels')
  const { t: transResponseMessage } = useTranslation('responseMessages')
  const dispatch = useDispatch()
  const [saving, setSaving] = useState(false)

  // The modal's button was written as `saveAddStatus(<on-way | pickup-on-way>)`,
  // but that function's parameter is commented out, so the status named here
  // was thrown away and the add-status form's current selection was sent
  // instead. This section sends the status it names, and so does its own
  // dispatch rather than sharing the form's: the form belongs to `statuses`, and
  // its selection and notification checkbox have no place in a booking.
  const status = parcel.currentStatus === 'created' ? 'on-way' : 'pickup-on-way'

  const book = async () => {
    setSaving(true)
    try {
      const { payload } = await dispatch(
        addParcelStatus({
          parcelId: parcel.parcelId,
          _id: parcel._id,
          addStatus: { name: status },
        })
      )
      // the server's messages are keyed with dashes where it wrote spaces
      showDashedResponseText(payload, transResponseMessage)
    } catch (e) {
      // addParcelStatus has already shown its own error when the request failed;
      // this is for anything thrown around it
      showProblem(transResponseMessage)
    } finally {
      setSaving(false)
      onChanged()
    }
  }

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="h6" align="center">
        {t('tryBookBox')}
      </Typography>
      <Button
        variant="contained"
        color="iboxen"
        size="small"
        disabled={saving}
        onClick={book}
      >
        {t('bookBox')}
      </Button>
    </Stack>
  )
}
